// extracted by mini-css-extract-plugin
export var arrow = "_le-1";
export var content = "_le-0";
export var highlighted = "_le-2";